import Vue from "@/plugins"
import { AxiosError, AxiosResponse } from "axios"
import { ActionTree } from "vuex"
import { State, StatisticsCounter } from "@/models"
import { GET_JWT_TOKEN } from "@/store/types/getters"
import { signIn, fetchStatistics, restartService } from "@/store/types/actions"
import { UAcsLoginModuleNamespace } from "@/consts"
import { notifySuccess, notifyRequestError } from "@/utils/notify"
import router from "@/router"
import { isEmpty } from "@/utils/validate"
import {
    UPDATE_STATISTICS,
    UPDATE_IS_RESTARTING,
} from "@/store/types/mutations"

const actions: ActionTree<State, any> = {
    [signIn]({ dispatch }): void {
        dispatch(UAcsLoginModuleNamespace + "/SIGN_IN", { root: true })
            .then(() => {
                notifySuccess("Successfully logged in")
                router.push({ name: "Dashboard" })
            })
            .catch((err: AxiosError) => {
                notifyRequestError(err, "Failed to Login")
            })
    },
    [fetchStatistics]({ commit, rootGetters }): void {
        if (isEmpty(rootGetters[GET_JWT_TOKEN])) {
            return
        }

        Vue.prototype
            .$api({
                method: "GET",
                url: `/api/v1/statistics`,
                headers: {
                    Authorization: "Bearer " + rootGetters[GET_JWT_TOKEN],
                },
            })
            .then((resp: AxiosResponse<StatisticsCounter>) => {
                commit(UPDATE_STATISTICS, resp.data)
            })
            .catch((err: AxiosError) => {
                notifyRequestError(err, "Faied to update statistics")
            })
    },
    [restartService]({ commit, rootGetters }): Promise<void> {
        if (isEmpty(rootGetters[GET_JWT_TOKEN])) {
            return Promise.resolve()
        }

        commit(UPDATE_IS_RESTARTING, true)

        return Vue.prototype.$api({
            method: "GET",
            url: `/api/v1/restart`,
            headers: {
                Authorization: "Bearer " + rootGetters[GET_JWT_TOKEN],
            },
        })
    },
}

export default actions
